export const aboutObjOne = {
    id: 'services',
    type: 1,
    lightBg: false,
    lightText: true,
    lighTextDesc: true,
    title1: 'Mision',
    title2: 'Vision',
    p1: 'Always deliver a product and / or service with responsibility, quality and reliability that gives added value to our clients and their processes.',
    p2: 'Grow and be recognized in the areas of Engineering, automation and machining solutions. Generating employment and growth opportunities in various cities, relying on the most avant-garde technology and taking care of customer service, always seeking to add value to your business and processes.',
    alt: 'Icon',
    dark: false,
    primary: true,
    darkText: false
};


